import { CardSecondary } from '@ferreri/prever-component-lib';
import { DependentInfo } from './DependentInfo';
import {
  ExtendedGroupType,
  KinshipType,
  SubscriptionDependentRuleType,
} from './rules.types';

type DependentCardType = {
  siblingGroup: ExtendedGroupType[];
  kinship: KinshipType;
  maxQuantity: number;
  maxQuantityAdditional: number;
  subscriptionRules: SubscriptionDependentRuleType[];
  hasAdditionalDependentGlobal: boolean;
};

export const DependentCard = (props: DependentCardType) => {
  return (
    <CardSecondary>
      <DependentInfo
        siblingGroup={props.siblingGroup}
        kinship={props.kinship.slug}
        maxQuantity={props.maxQuantity}
        maxQuantityAdditional={props.maxQuantityAdditional}
        subscriptionRules={props.subscriptionRules}
        hasAdditionalDependentGlobal={props.hasAdditionalDependentGlobal}
      />
    </CardSecondary>
  );
};
